import React from 'react';
import PropTypes from 'prop-types';
import FalconCardFooterLink from 'components/common/FalconCardFooterLink';
import FalconCardHeader from 'components/common/FalconCardHeader';
import CardDropdown from 'components/common/CardDropdown';
import { Card } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { Link, useNavigate } from 'react-router-dom';
import Avatar from 'components/common/Avatar';
import classNames from 'classnames';
import paths from 'routes/paths';

const ActiveUsers = ({ users, end = 5, ...rest }) => {
  const navigate = useNavigate();

  return (
    <Card
      {...rest}
      role="button"
      tabIndex={0}
      onClick={() => navigate(paths.analytics)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate(paths.analytics);
        }
      }}
      style={{ cursor: "pointer" }}
    >
      <FalconCardHeader
        light
        title="Active Users"
        titleTag="h6"
        className="py-2"
        endEl={<CardDropdown />}
      />
      <Card.Body className="py-2">
        {users.slice(0, end).map(({ id, ...rest }, index) => (
          <ActiveUser {...rest} key={id} isLast={index === users.length - 1} />
        ))}
      </Card.Body>
      <FalconCardFooterLink
        title="All active users"
        to={paths.followers}
        size="sm"
        onClick={(e) => e.stopPropagation()}
      />
    </Card>
  );
};

const ActiveUser = ({ name, avatar, role, isLast }) => (
  <Flex
    className={classNames('align-items-center position-relative', {
      'mb-3': !isLast
    })}
  >
    <Avatar {...avatar} className={`status-${avatar.status}`} />
    <div className="ms-3">
      <h6 className="mb-0 fw-semibold">
        <Link
          className="text-900 stretched-link"
          to={paths.userProfile}
          onClick={(e) => e.stopPropagation()}
        >
          {name}
        </Link>
      </h6>
      <p className="text-500 fs-11 mb-0">{role}</p>
    </div>
  </Flex>
);

ActiveUser.propTypes = {
  name: PropTypes.string.isRequired,
  avatar: PropTypes.object,
  role: PropTypes.string,
  isLast: PropTypes.bool
};

ActiveUsers.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape(ActiveUser.propTypes)),
  end: PropTypes.number
};

export default ActiveUsers;
